import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BrowseTypes, PageTypes, QueryTerms } from 'src/app/shared/models/QueryTerms';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  page: PageTypes;
  type: BrowseTypes;

  isPCPSearch: boolean = false;
  showLoginForm!: boolean;
  showBrowseForm!: boolean;
  showEmployerForm!: boolean;
  queryParamMap;
  @Input() clickedSearchCriteria;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.page = PageTypes[this.router.parseUrl(router.url).root.children['primary'].segments.map(it => it.path).join('/')];
  }

  ngOnInit() {
    this.queryParamMap = null;
    if (this.activatedRoute.snapshot.queryParamMap.keys.length > 0) {
      this.queryParamMap = this.activatedRoute.snapshot.queryParamMap;
    }

    this.activatedRoute.queryParams.subscribe(params => {
      this.type = params[QueryTerms.type];
    });
    this.showLoginForm = [BrowseTypes.find, BrowseTypes.shop, BrowseTypes.employer].includes(this.type) || [PageTypes.find].includes(this.page);
    this.showBrowseForm = this.showLoginForm ? false : [PageTypes.browse, PageTypes.search, PageTypes.findpcp, PageTypes.medication].includes(this.page) && ![BrowseTypes.find].includes(this.type);
    this.showEmployerForm = [PageTypes.employergroup].includes(this.page);
  }

  isShowMedicationIssueMessage() {
    let currentDate = new Date().getTime();
    let targetDate = new Date('2025-01-06').setHours(5, 0, 0, 0);
    return currentDate < targetDate;
  }
  
}
